<template>
  <v-container py-0>
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.active') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="!!match.active" />
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.matches.started') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="!!match.started" />
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.matches.finalized') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="!!match.ended" />
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.matches.status') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ match.status }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.date') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(match.date) }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.time') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ match.time }}
            <span
              v-if="match.wtz && match.wtz != $store.state.offset"
              style="font-size: 11px"
              >{{ ` (GMT ${match.wtz})` }}</span
            >
          </v-flex>
        </v-layout>

        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.matches.homeTeam') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip v-if="match.homeTeamId" color="white" small>
              <v-avatar size="32" style="padding: 0">
                <img :src="match.homeTeamId.logo" alt />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ match.homeTeamId.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="match.homeTeamId.categories"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ match.homeTeamId.categories.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.matches.visitorTeam') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip v-if="match.visitorTeamId" color="white" small>
              <v-avatar size="32" style="padding: 0">
                <img :src="match.visitorTeamId.logo" alt />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ match.visitorTeamId.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="match.visitorTeamId.categories"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ match.visitorTeamId.categories.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.type') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ match.type }}
          </v-flex>
        </v-layout>
        <template v-if="match.tournamentId">
          <v-divider />
          <v-layout row wrap my-2>
            <v-flex xs12 md4 class="body-2">
              {{ $tc('models.tournament') }}
            </v-flex>
            <v-flex xs12 md6>
              <v-chip color="white" small>
                <v-avatar size="32" style="padding: 0">
                  <img :src="match.tournamentId.img" alt />
                </v-avatar>
                {{ match.tournamentId.name }}
              </v-chip>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="match.categories">
          <v-divider />
          <v-layout row wrap my-2>
            <v-flex xs12 md4 class="body-2">
              {{ $tc('models.category') }}
            </v-flex>
            <v-flex xs12 md6>
              <template v-for="(category, index) in match.categories">
                <v-chip :key="index + category" small color="primary" dark>
                  {{ category }}
                </v-chip>
              </template>
            </v-flex>
          </v-layout>
          <v-divider />
          <v-layout row wrap my-2>
            <v-flex xs12 md4 class="body-2">
              {{ $t('fields.matches.session') }}
            </v-flex>
            <v-flex xs12 md6>
              {{ match.session }}
            </v-flex>
          </v-layout>
        </template>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.location') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-chip v-if="match.location" color="white" small>
              <v-avatar size="32">
                <img :src="match.location.photo" alt />
              </v-avatar>
              {{ match.location.name }}
            </v-chip>
            <span v-else>--</span>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdBy') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ match.createdBy }}
          </v-flex>
        </v-layout>
        <v-divider />
        <v-layout row wrap my-2>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdAt') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(match.createdAt, true) }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'TabView',
  props: {
    match: {
      type: Object,
      default: () => {},
      required: true,
    },
  },

  methods: {
    formatDate(date, time = false) {
      return formatDate(date, time)
    },
  },
}
</script>
